var _filter, _filter2, _marker, _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _path, _circle, _path2, _circle2, _path3, _path4, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg07TurnServer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "turnGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d97706"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerGradTurn",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4f46e5"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "firewallGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#b91c1c"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glowOrange",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "shadowTurn",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 10,
    floodOpacity: 0.3
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowYellow",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#fbbf24"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 500,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    TURN Server - When STUN Fails\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 65,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Traversal Using Relays around NAT\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -20,
    width: 160,
    height: 40,
    rx: 8,
    fill: "url(#firewallGrad)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    y: 6,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "\uD83D\uDD12 Symmetric NAT"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -20,
    width: 160,
    height: 40,
    rx: 8,
    fill: "url(#firewallGrad)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    y: 6,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "\uD83D\uDD25 Strict Firewall"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -200 0 L 200 0",
    stroke: "#ef4444",
    strokeWidth: 3,
    strokeDasharray: "10,10",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#ef4444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "\n      \u274C Direct P2P not possible\n    "), /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#7f1d1d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -8,
    x2: 8,
    y2: 8,
    stroke: "#ef4444",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: -8,
    x2: -8,
    y2: 8,
    stroke: "#ef4444",
    strokeWidth: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 200)",
    filter: "url(#shadowTurn)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -50,
    width: 140,
    height: 100,
    rx: 16,
    fill: "url(#peerGradTurn)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "Peer A"), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Behind Symmetric NAT"), /*#__PURE__*/React.createElement("text", {
    y: 25,
    textAnchor: "middle",
    fill: "#c7d2fe",
    fontFamily: "monospace",
    fontSize: 10
  }, "192.168.1.5"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(780, 200)",
    filter: "url(#shadowTurn)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -50,
    width: 140,
    height: 100,
    rx: 16,
    fill: "url(#peerGradTurn)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "Peer B"), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Strict Firewall"), /*#__PURE__*/React.createElement("text", {
    y: 25,
    textAnchor: "middle",
    fill: "#c7d2fe",
    fontFamily: "monospace",
    fontSize: 10
  }, "192.168.2.10"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 350)",
    filter: "url(#shadowTurn)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -50,
    width: 160,
    height: 100,
    rx: 20,
    fill: "url(#turnGrad)",
    filter: "url(#glowOrange)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 70,
    fill: "none",
    stroke: "#fcd34d",
    strokeWidth: 2,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "70;80;70",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0.2;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "TURN"), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#fef3c7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Relay Server"), /*#__PURE__*/React.createElement("text", {
    y: 28,
    textAnchor: "middle",
    fill: "#fde68a",
    fontFamily: "monospace",
    fontSize: 10
  }, "Public IP: 203.0.113.100"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 180 240 Q 280 310 370 340",
    stroke: "#fbbf24",
    strokeWidth: 4,
    fill: "none",
    markerEnd: "url(#arrowYellow)",
    strokeDasharray: "10,5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-30",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#fbbf24"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    path: "M 180 240 Q 280 310 370 340"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 530 340 Q 630 310 720 240",
    stroke: "#fbbf24",
    strokeWidth: 4,
    fill: "none",
    markerEnd: "url(#arrowYellow)",
    strokeDasharray: "10,5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-30",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#fbbf24"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.75s",
    path: "M 530 340 Q 630 310 720 240"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 720 250 Q 630 320 530 350",
    stroke: "#818cf8",
    strokeWidth: 3,
    fill: "none",
    strokeDasharray: "8,4",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 370 350 Q 280 320 180 250",
    stroke: "#818cf8",
    strokeWidth: 3,
    fill: "none",
    strokeDasharray: "8,4",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -12,
    width: 60,
    height: 24,
    rx: 12,
    fill: "#d97706"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Relay"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(640, 280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -12,
    width: 60,
    height: 24,
    rx: 12,
    fill: "#d97706"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600
  }, "Relay"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 440)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 50,
    rx: 10,
    fill: "#451a03",
    stroke: "#f59e0b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 22,
    fill: "#fcd34d",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#fbbf24",
    fontWeight: "bold"
  }, "\u26A0\uFE0F TURN adds latency"), " \u2014 data goes through relay\n    "), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 40,
    fill: "#a16207",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "\n      Used only when direct connection is impossible\n    "))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(470, 440)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 50,
    rx: 10,
    fill: "#451a03",
    stroke: "#f59e0b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 22,
    fill: "#fcd34d",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#fbbf24",
    fontWeight: "bold"
  }, "\uD83D\uDCB0 TURN costs money"), " \u2014 requires bandwidth\n    "), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 40,
    fill: "#a16207",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "\n      Unlike STUN, TURN relays all media traffic\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07TurnServer);
export default __webpack_public_path__ + "static/media/07-turn-server.7ebd76c149dc39daf4c09a46185b8547.svg";
export { ForwardRef as ReactComponent };